<template>
  <span>
    {{ amount_formatted }}
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  amount: { type: Number, required: false, default: null },
  with_currency_symbol: { type: Boolean, default: true },
  minimum_fraction_digits: { type: Number, default: 0 },
});

const store = useStore();

const current_profile = computed(() => store.getters.current_profile);

const amount_formatted = computed(() => {
  const { amount, with_currency_symbol, minimum_fraction_digits } = props;

  if (_.isNil(amount) || amount === '') return '';

  return current_profile.value.formatCurrency(amount, {
    with_currency_symbol,
    minimumFractionDigits: minimum_fraction_digits,
  });
});
</script>
